<template>
    <div class="visa_profile_container" v-if="visa" >
        <div class="sp_student_about_container">
            <div class="std_about_container sp_student_image_container">
                <div class="sp_student_image student_info_box">
                   
                    <img :src="visa.profile_image" v-if="visa.profile_image" alt="profile">
                   
                    <img v-else src="@/assets/dummy.png" alt="profile">
               
                    <!-- <div class="sp_image_update">Update</div> -->
                </div> 
                <div class="sp_student_name student_info_box"> {{visa.name}}</div>
                    <!-- <div title="Edit Student Profile" class="edit_profile">
                        <i class="material-icons">edit</i>
                    </div> -->
            </div> 
            <div class="std_about_container sp_student_id_container">
                <div class="student_info_box student_id">
                    <div class="student_info_title">Student ID</div>
                    <div class="student_info">{{ visa.code }}</div>
                </div>
                <div class="student_info_box student_adm_date">
                    <div class="student_info_title">Admission Date</div> 
                    <div class="student_info">{{visa.visa.intake_date}}</div>
                </div>
            </div> 
            <div class="std_about_container sp_student_contact_info_container">
                <div class="student_about_info student_contact_no">
                    <i class="material-icons">phone</i> 
                    <div class="student_info">{{visa.phone}}</div>
                </div> 
                <div class="student_about_info student_mail">
                    <i class="material-icons">mail</i>
                    <div class="student_info">{{visa.email}}</div>
                </div> 
            </div> 
            <div class="std_about_container sp_student_personal_info_container">
                <div class="student_info_box student_dob">
                    <div class="student_info_title">D.O.B.</div> 
                    <div class="student_info">{{visa.dob}}</div>
                </div>
                <div class="student_info_box student_gender">
                    <div class="student_info_title">Gender</div> 
                    <div class="student_info">
                    <span v-if="visa.gender">{{visa.gender}}</span><span v-else>N/a</span>
                    </div>
                </div>
            </div>  
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
    computed: {
        ...mapGetters(['visa'])
    }
}
</script>



// WEBPACK FOOTER //
// src/components/VisaDetail/VisaProfile.vue